var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-container",domProps:{"innerHTML":_vm._s(_vm.iconHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }